/**
 * Words on the public event and checkout screens (Event Tickets plan
 * 2026-10-19, U4, U5). One sentence each.
 */

import type { PublicSalesState } from '@/utils/eventTickets/publicTicketTypes';
import { PUBLIC_TICKETS_COPY } from '@/utils/eventTickets/publicTicketTypes';

export const PUBLIC_EVENT_COPY = {
  EVENTS_TAB: 'Events',
  VIEW_DETAILS: 'View Details',
  FEES_INCLUDED: 'fees included',
  CONTINUE: 'Continue to payment',
  PICK_TICKETS: 'Pick at least one ticket.',
  EMAIL_HINT: 'Your tickets go to this email.',
  WALLETS: 'Card, Apple Pay, or Google Pay.',
  HELD_FOR: 'Your tickets are held for',
  HOLD_RAN_OUT: 'Your hold ran out. Tap Pay and we’ll check the tickets are still available.',
  CONFIRMING: 'Confirming your payment…',
  PAY_FAILED: 'Payment failed. Please try again.',
  BACK: 'Back to tickets',
  SOLD_OUT_TITLE: 'Sold out',
  SOLD_OUT_BODY: 'These tickets sold out before you paid. You were not charged.',
  NO_EVENTS: 'No events right now.',
  SALES_CLOSE: 'Online sales close',
} as const;

/** One line under an event that is not simply on sale; null when it is. */
export function salesStateLabel(state: PublicSalesState): string | null {
  switch (state) {
    case 'sold_out':
      return PUBLIC_TICKETS_COPY.SOLD_OUT;
    case 'sales_closed':
      return PUBLIC_TICKETS_COPY.SALES_CLOSED;
    case 'all_held':
      return PUBLIC_TICKETS_COPY.ALL_HELD;
    default:
      return null;
  }
}
